import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import "../css/contact.css";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

library.add(fas, fab);

export default function Contact() {
  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.from(".contact-info-container", {
      scrollTrigger: {
        trigger: ".contact-section",
        start: "top center",
      },
      opacity: 0,
      duration: 1.25,
      ease: "power3.out",
      y: 40,
    });
  });
  return (
    <section className="contact-section" id="contact">
      <div className="contact-main-container">
        <div className="contact-info-container">
          <div className="text-info">
            <h1>Contact Us</h1>
            <h4>
              hilary@lawrencelawoffice.net <br />
              949-257-7116{" "}
            </h4>
            <h4>1201 Puerta Del Sol San Clemente, CA 92673</h4>
          </div>
          <div className="info-logo">
            <FontAwesomeIcon
              icon="fa-brands fa-facebook-f"
              className="info-icon"
            />
            <FontAwesomeIcon
              icon="fa-brands fa-linkedin-in"
              className="info-icon"
            />
          </div>
        </div>
        <div className="form-container">
          <div>
            <p>Name (required)</p>
          </div>
          <div className="form-name-container">
            <div>
              <h5>First Name</h5>
              <input type="text" title="First Name" />
            </div>
            <div>
              <h5>Last Name</h5>
              <input type="text" title="Last Name" />
            </div>
          </div>
          <div>
            <p>Email (required)</p>
          </div>
          <div className="form-email-container">
            <input type="email" title="Email" required />
          </div>
          <div className="contact-btn-submit">
            <button>Send</button>
          </div>
        </div>
      </div>
    </section>
  );
}
